const mainHero = document.querySelector(".solstice__main-hero-glide");
const slides = mainHero?.querySelectorAll(".glide__slides > li") || [];
const autoplay = mainHero.dataset.autoplay;
const autoplayDuration = mainHero.dataset.autoplayDuration;

const mainHero__leftButtons = document.querySelectorAll(
  ".solstice__main-hero-glide-controls-left"
);
const mainHero__rightButtons = document.querySelectorAll(
  ".solstice__main-hero-glide-controls-right"
);

if (slides.length > 1) {
  // Initialize Glide
  const mainHero_glide = new Glide(".solstice__main-hero-glide", {
    type: "slider",
    perView: 1,
    autoplay: autoplay === "true" ? 3000 : false,
  });

  mainHero__leftButtons.forEach((button) => {
    button.addEventListener("click", () => mainHero_glide.go("<"));
  });

  mainHero__rightButtons.forEach((button) => {
    button.addEventListener("click", () => mainHero_glide.go(">"));
  });

  mainHero_glide.mount();
} else {
  // Hide buttons if only 1 or 0 slides
  mainHero__leftButtons.forEach((button) => (button.style.display = "none"));
  mainHero__rightButtons.forEach((button) => (button.style.display = "none"));
}
